/**
 * Contact form functionality
 * - Validates form inputs
 * - Handles form submission
 */

export function initContactForm(form) {
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    
    // Get form inputs
    const nameInput = form.querySelector('#name');
    const emailInput = form.querySelector('#email');
    const phoneInput = form.querySelector('#phone');
    const messageInput = form.querySelector('#message');
    
    // Reset previous error messages
    const errorElements = form.querySelectorAll('.error-message');
    errorElements.forEach(element => element.textContent = '');
    
    // Validate inputs
    let isValid = true;
    
    // Name validation
    if (!nameInput.value.trim()) {
      displayError(nameInput, 'Name is required');
      isValid = false;
    }
    
    // Email validation
    if (!validateEmail(emailInput.value)) {
      displayError(emailInput, 'Please enter a valid email address');
      isValid = false;
    }
    
    // Phone validation (optional but must be valid if provided)
    if (phoneInput.value && !validatePhone(phoneInput.value)) {
      displayError(phoneInput, 'Please enter a valid phone number');
      isValid = false;
    }
    
    // Message validation
    if (!messageInput.value.trim()) {
      displayError(messageInput, 'Message is required');
      isValid = false;
    }
    
    // If form is valid, show success message
    if (isValid) {
      // In a real implementation, you would submit the form data to a server here
      // For this static site, we'll just show a success message
      form.reset();
      showFormMessage('Your message has been sent successfully. We will contact you soon!', 'success');
    }
  });
  
  // Helper function to display error message
  function displayError(input, message) {
    const errorElement = input.nextElementSibling;
    if (errorElement && errorElement.classList.contains('error-message')) {
      errorElement.textContent = message;
    }
  }
  
  // Helper function to validate email
  function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  
  // Helper function to validate phone
  function validatePhone(phone) {
    // Simple validation for demonstration - allows '+', spaces, and digits
    const re = /^[+\s0-9]{8,15}$/;
    return re.test(String(phone));
  }
  
  // Helper function to show form message
  function showFormMessage(message, type) {
    const messageContainer = document.querySelector('#formMessage');
    if (messageContainer) {
      messageContainer.textContent = message;
      messageContainer.classList.remove('hidden', 'text-red-500', 'text-green-500');
      
      if (type === 'success') {
        messageContainer.classList.add('text-green-500');
      } else {
        messageContainer.classList.add('text-red-500');
      }
      
      // Hide the message after 5 seconds
      setTimeout(() => {
        messageContainer.classList.add('hidden');
      }, 5000);
    }
  }
}